import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=4120bf6e&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=ts"
export * from "./Shipping.vue?vue&type=script&lang=ts"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=4120bf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120bf6e",
  null
  
)

export default component.exports